import { defineNuxtPlugin } from '#imports'
import { createAxiosClientAnonymous } from '@b2ag/axios'
import { provideFeatureFlipping, useFeatureFlipping } from '@b2ag/feature-flipping'
import { getAppContext, getConfig } from '@b2ag/micro-front-tools'
import { currentAppBrand } from '@b2ag/app-brands'
import { getStore } from '@/app/store'

function updateFeatureFlipping(coopId: number, membershipCode: string) {
  return useFeatureFlipping().updateFeatureFlipping(coopId, membershipCode)
}

export default defineNuxtPlugin({
  name: 'feature flipping',
  enforce: 'pre',
  dependsOn: ['store'],
  async setup() {
    const { appFrontType } = getAppContext()
    const featureFlippingApiClient = createAxiosClientAnonymous(`${getConfig('FEATURE_FLIPPING_API_HOST')}`)
    const store = getStore()

    provideFeatureFlipping(featureFlippingApiClient, appFrontType, currentAppBrand)

    if (appFrontType === 'agri') {
      await updateFeatureFlipping(store.getters.currentCooperativeId, store.getters.currentMembershipNumber)
    } else if (appFrontType === 'tech') {
      const { getUserTechRoleFromAccessToken } = await import('@b2ag/user/src/user-role.service')
      getUserTechRoleFromAccessToken().then(async (techRole) => {
        if (techRole) {
          const [{ cooperative }] = techRole.profiles
          await updateFeatureFlipping(cooperative.id, cooperative.membershipNumber)
        }
      })
    }
  },
})
